/**
 * Created by olga on 22.09.2025
 */

const Merge2CustomersQueue = function (customers) {
    this.customers = customers;
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.CUSTOMERS_QUEUE) || {};

    this.maxBatchReserve = this.getBatchReserve();
    this.maxCustomerIndex = this.customers.getMaxCustomerIndex();

    this.batchTime = data.batchTime || 0;
    this.reserve = data.reserve !== undefined ? data.reserve : this.maxBatchReserve;
    this.queue = data.queue || [];
    this.refillTime = data.refillTime || 0;
   
    this.update();
    this.runInterval();

    cleverapps.meta.on("progressChanged", this.onLocationNextStage.bind(this), this);
};

Merge2CustomersQueue.prototype.remove = function (customerIndex) {
    const index = this.queue.indexOf(customerIndex);

    if (index !== -1) {
        this.queue.splice(index, 1);
    }
};

Merge2CustomersQueue.prototype.onLocationNextStage = function () {
    const maxBatchReserve = this.getBatchReserve();
    const maxCustomerIndex = this.customers.getMaxCustomerIndex();

    if (maxBatchReserve !== this.maxBatchReserve || maxCustomerIndex !== this.maxCustomerIndex) {
        this.maxBatchReserve = maxBatchReserve;
        this.maxCustomerIndex = maxCustomerIndex;
        this.reset();
    }
};

Merge2CustomersQueue.prototype.reset = function () {
    this.batchTime = Date.now();
    this.reserve = this.getBatchReserve();
    this.queue = [];
    this.refillTime = 0;
    Merge2.current.counter.trigger();
    this.save();
};

Merge2CustomersQueue.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.CUSTOMERS_QUEUE, this.getData());
};

Merge2CustomersQueue.prototype.getBatchReserve = function () {
    const location = cleverapps.meta.getSelectedLocation();
    const stage = location.getContinuousStage();

    return Merge2CustomersQueue.BATCH_RESERVE_CONFIG.find((cfg) => stage >= cfg.availableByFix).batch;
};

Merge2CustomersQueue.prototype.getData = function () {
    return {
        batchTime: this.batchTime,
        reserve: this.reserve,
        queue: this.queue,
        refillTime: this.refillTime
    };
};

Merge2CustomersQueue.prototype.update = function () {
    const now = Date.now();
    if (!this.batchTime || now - this.batchTime >= cleverapps.parseInterval(Merge2CustomersQueue.DURATION)) {
        this.reset();
    } else if (this.refillTime && now >= this.refillTime) {
        const refillDuration = cleverapps.parseInterval(Merge2CustomersQueue.REFILL_COOLDOWN);

        while (this.refillTime && now >= this.refillTime && this.queue.length) {
            this.shift();
            this.refillTime = this.queue.length > 0 ? this.refillTime + refillDuration : 0;
        }

        this.refillTime = this.queue.length > 0 ? this.refillTime : 0;
        this.save();
        Merge2.current.counter.trigger();
    }
};

Merge2CustomersQueue.prototype.clearInterval = function () {
    if (this.updateInterval) {
        cleverapps.timeouts.clearInterval(this.updateInterval);
        delete this.updateInterval;
    }
};

Merge2CustomersQueue.prototype.has = function (customerIndex) {
    return this.queue.includes(customerIndex);
};

Merge2CustomersQueue.prototype.shift = function () {
    return this.queue.shift();
};

Merge2CustomersQueue.prototype.add = function (customerIndex) {
    if (this.reserve > 0) {
        this.reserve--;
    } else {
        if (this.has(customerIndex)) {
            return;
        }

        this.queue.push(customerIndex);

        if (!this.refillTime) {
            this.refillTime = Date.now() + cleverapps.parseInterval(Merge2CustomersQueue.REFILL_COOLDOWN);
        }
    }

    this.save();
};

Merge2CustomersQueue.prototype.runInterval = function () {
    this.clearInterval();

    this.updateInterval = cleverapps.timeouts.setInterval(this.update.bind(this), Merge2CustomersQueue.UPDATE_INTERVAL);
};

Merge2CustomersQueue.BATCH_RESERVE_CONFIG = [
    { batch: 3, availableByFix: 11 },
    { batch: 11, availableByFix: 5 },
    { batch: 9, availableByFix: 0 }
];

Merge2CustomersQueue.DURATION = "1 hour";
Merge2CustomersQueue.REFILL_COOLDOWN = "20 minutes";
Merge2CustomersQueue.UPDATE_INTERVAL = cleverapps.parseInterval("10 seconds");